import { ReadonlyRadioGroup } from '@exam-center/components';
import { Box, Flex, Grid, SectionTitle, Text } from '@shared/components';

export interface ResultDisplaySettingsReadonlyFieldsProps {
  values: {
    shouldDisplay: boolean;
    resultSend: {
      portal: boolean;
    };
  };
}

export default function ResultDisplaySettingsReadonlyFields(
  props: Readonly<ResultDisplaySettingsReadonlyFieldsProps>,
) {
  const { values } = props;

  return (
    <>
      <SectionTitle title='Result Display Settings' />
      <Grid sx={{ gap: (theme) => theme.spacing(6), gridTemplate: '1fr / 240px 1fr' }}>
        <Box>
          <Text variant='body1Semibold'>การแสดงผลสอบ (ผ่าน/ไม่ผ่าน)</Text>
        </Box>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4), maxWidth: '200px' }}>
          <ReadonlyRadioGroup
            options={[
              {
                label: 'ไม่แสดงผลสอบ',
                checked: values.shouldDisplay === false,
              },
              {
                label: 'แสดงผลสอบ',
                checked: values.shouldDisplay === true,
              },
            ]}
          />
        </Flex>
      </Grid>
      <Grid sx={{ gap: (theme) => theme.spacing(6), gridTemplate: '1fr / 240px 1fr' }}>
        <Box>
          <Text variant='body1Semibold'>การส่งผลสอบไปยัง SET Portal</Text>
        </Box>
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
          <ReadonlyRadioGroup
            options={[
              {
                label: 'ไม่ส่งผลสอบ',
                checked: values.resultSend.portal === false,
              },
              {
                label: 'ส่งผลสอบ',
                checked: values.resultSend.portal === true,
              },
            ]}
          />
        </Flex>
      </Grid>
    </>
  );
}
